module.exports = __webpack_public_path__ + "img/giftBox.a0cf2541.png";